import React from 'react'
import playInUploadModalStyles from './playInUploadModal.module.scss'
import Modal from '@bt-react/components/Modal'
import Button from '@bt-react/components/Button'
import { IconType } from '@bt-react/components/Icon'
import ChannelList from '../PlayInList/ChannelList'
import PlayInList from '../PlayInList'
import SearchBox from '../SearchBox'
import EmptyPlayInList from '../PlayInList/EmptyPlayInList'
import classNames from 'classnames'

export interface PlayInUploadModalProps {
  hideModal(): void
  isOpen?: boolean
}

class PlayInUploadModal extends React.Component<PlayInUploadModalProps> {

  columns: React.JSX.Element[] = [
    <>
      <div
        className={classNames(playInUploadModalStyles[`heading`],  playInUploadModalStyles['heading-text-400'])}>
        Available in this channel
      </div>
      <div
        className={playInUploadModalStyles[`select-content`]}>
        <div className={playInUploadModalStyles[`search-box-wrapper`]}>
          <SearchBox />
        </div>
        <ChannelList
          dataBdd="available-playins"
          listHeight={460}
          emptyRenderer={() => <></>}
        />
      </div>
    </>,
   <>
     <div
       className={classNames(playInUploadModalStyles[`heading`], playInUploadModalStyles['heading-text-400'])}
     >
     Video list
     </div>
     <PlayInList
       dataBdd="added-playins"
       listHeight={520}
       emptyRenderer={EmptyPlayInList}
       showRemoveButton={true}
     />
   </>
  ]

  onConfirm = () => {

    this.props.hideModal()

  }

  render () {

    const {
      isOpen = true
    } = this.props

    return <Modal
      concise={true}
      hideBorder={true}
      isOpen={isOpen}
      className={playInUploadModalStyles[`playin-upload-modal`]}
    >
      <Modal.Body
        className={playInUploadModalStyles[`content`]}
        dataBdd={`dialog-confirm-body`}
      >
        <div
          className={playInUploadModalStyles[`column`]}>
          {this.columns[0]}
        </div>

        <div
          className={playInUploadModalStyles[`column`]}>
          {this.columns[1]}
        </div>
      </Modal.Body>
      <Modal.Footer
        className={playInUploadModalStyles[`footer`]}
      >
        <Button
          color={IconType.colour.primary}
          text="Done"
          dataBdd="dialog-button-confirm"
          onClick={this.onConfirm}
        />
      </Modal.Footer>
    </Modal>

  }

}

export default PlayInUploadModal
